import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src118217614/src/nuxt/layouts/default.vue").then(m => m.default || m))
}